'use client';

import { UserButton } from '@clerk/nextjs';
import { Heart, KeyRound } from 'lucide-react';

/** The boats this account has saved — Clerk-protected, see `app/favourite-boats`. */
const FAVOURITE_BOATS_PATH = '/favourite-boats';

/** Self-service API key management — Clerk-protected, see `app/account/api-keys`. */
const API_KEYS_PATH = '/account/api-keys';

/**
 * The account menu, for both breakpoints.
 *
 * One component rather than a copy per header: the drawer used to carry its own hand-rolled list of
 * account links beside this, and the two drifted — favourites reached the drawer months before it
 * reached the desktop menu, and a link added to one was simply missing from the other. Everything
 * account-shaped now hangs off Clerk's own menu, which also means sign-out and profile come from
 * Clerk rather than being wired up twice.
 */
export const AccountUserButton: React.FC = () => (
  <UserButton
    showName
    appearance={{
      elements: {
        // Clerk lays the trigger out `row-reverse`, which puts the name ahead of the avatar; we
        // want the avatar first and the name after it.
        userButtonBox: { flexDirection: 'row-reverse' },
        // Light by default, for the dark mobile drawer. The desktop header sits on white and sets
        // `--account-user-name-color` to a dark ink instead — see `Header.module.scss`.
        userButtonOuterIdentifier: { color: 'var(--account-user-name-color, #fff)' },
      },
    }}
  >
    <UserButton.MenuItems>
      <UserButton.Link label="Favourite boats" labelIcon={<Heart size={16} />} href={FAVOURITE_BOATS_PATH} />
      <UserButton.Link label="API keys" labelIcon={<KeyRound size={16} />} href={API_KEYS_PATH} />
    </UserButton.MenuItems>
  </UserButton>
);
